export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Employees",
      layout: "dashboard",
    },
    path: "/employees",
    name: "employees",
    component: () => import("@/layouts/index/EmployeeIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Employees",
          layout: "dashboard",
        },
        path: "employees/index",
        name: "employees-index",
        component: () => import("@/views/employees/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter un employé",
          layout: "dashboard",
        },
        path: "employees/create",
        name: "employees-create",
        component: () => import("@/views/employees/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un employé",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "employees-edit",
        component: () => import("@/views/employees/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier un employé",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "employees-details",
        component: () => import("@/views/employees/Details.vue"),
      },
    ],
  },
];
